<template>
  <div class="addModel">
    <div class="addfrom">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" labelPosition='left'>
        <el-row>
          <el-col :span="24">
            <el-form-item label="机构名称：" prop="mechanismBaseName">
              <el-input v-model="ruleForm.mechanismBaseName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class='footer'>
        <el-button v-waves class="mybtny" @click="submit">确定</el-button>
        <el-button v-waves class="mybtny" @click="resetForm">重置</el-button>
        <el-button v-waves class="mybtnn" @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/util/request';
export default {
  data() {
    return {
      ruleForm: {
        mechanismBaseName: '',
      },
      rules: {
        mechanismBaseName: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ],
      },
    };
  },
  methods: {
    submit() {
      let that = this;
      that.$refs.ruleForm.validate((valid) => {
        if (valid) {
          that.$emit("submit", that.ruleForm, true);
        } else {
          return false;
        }
      });
    },
    cancel() {
      this.$emit("cancel");
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
}
</script>

<style lang='less' scoped>
.addModel {
  .addfrom {
    margin: 0 30px;
    .topcontent {
      margin-bottom: 20px;
      .el-row {
        margin-bottom: 0;
        height: 40;
      }
      p {
        padding: 0 10px;
      }
    }
    .el-row {
      margin-bottom: 22px;
      &:last-child {
        // margin-bottom: 0;
      }
      /deep/.el-input__inner {
        height: 33px;
        width: 80%;
      }
      /deep/.el-select {
        width: 160px;
        /deep/.el-input__inner {
          width: 100%;
        }
      }
      .el-col-7,.el-col-8,.el-col-9 {
        height: 32px;
      }
      /deep/.el-form-item {
        margin-bottom: 10px;
      }
      /deep/.el-form-item__label {
        padding: 0;
      }
    }
  }
  /deep/.el-button {
    width: 100px;
  }
  .footer {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/MechanismMana/components/addProject.vue